<div class="loading-spinner">
		<img src="../../../../assets/img/Ellipsis.gif" width="80px" />
</div>
